export default __webpack_public_path__ + "static/media/azure-vpn-gateway.51a0efae.svg";